<!--
  File name: PBNEFResultModal.vue
  Program Description:
    - This component renders the list of PBNEF Results.
  Includes:
    - Function that downloads PBNEF uploaded resolution.
-->
<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
  >
    <v-card class="pa-5">
      <v-card-title class="pl-0">
        <h3>
          Preliminary Breach Notification Evaluation Form
          <v-btn
            class="close-btn"
            icon
            @click="dialog = !dialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </h3>
      </v-card-title>
      <v-card
        v-for="item in items"
        :key="item.pbnefId"
        :item="item"
        elevation="4"
        class="pa-2 mb-6"
      >
        <v-card-text class="pb-0">
          <h3 class="d-flex justify-space-between">
            <span class="primary--text">Type of request</span>
            <v-chip
              :class="getStatusColor(item.evaluation)"
              disabled
            >
              {{ item.evaluation }}
            </v-chip>
          </h3>
          <h4 class="ml-3">
            {{ item.typeOfRequest.map(formattedTypeOfRequestText).join(', ') }}
          </h4>
        </v-card-text>
        <v-card-text>
          <h3 class="primary--text">
            Resolution
          </h3>
          <FileInputUpload
            :value="[item.resolution]"
            :entry-id="item.pbnefId"
            dense
            clearable
            show-download
            accept=".pdf"
            file-id="fileUpload"
            field-name="fileUpload"
            collection="pbnef"
            can-view-file
          />
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>
<script>
import { toOrdinal } from '@/utils/helpers.js'
export default {
  name: 'PBNEFResultModal',
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    dialog: true
  }),
  computed: {
    formattedTypeOfRequestText () {
      return text => {
        if (text === 'Request for exemption') return `${text} to notify data subject`
        if (!text.includes('Request for extension')) return text
        const numberOfRequest = text.split(' ')[0].replace(/[{()}]/g, '')
        if (isNaN(parseInt(numberOfRequest))) return text
        return toOrdinal(numberOfRequest) + ' Request for extension'
      }
    }
  },
  methods: {
    getStatusColor (status) {
      if (status === 'Denied') return 'red lighten-5 red--text text--darken-1'
      return 'green lighten-5 green--text text--darken-1'
    }
  }
}
</script>

<style scoped>
.close-btn {
  position: absolute;
  top: 33px;
  right: 20px;
}
</style>
